import imported_asset_index_tsx_0 from '../../assets/Uploads/corp.png';
import imported_asset_index_tsx_1 from '../../assets/Uploads/rocket.svg';
import imported_asset_index_tsx_2 from '../../assets/Uploads/report.svg';
import imported_asset_index_tsx_3 from '../../assets/Uploads/secure.svg';
import MainContent from '../../components/common/main-content';
import MainBoxes from '../../components/common/main-boxes';
import CookieCommonConsent from "../../components/common/cookie-consent";

const HomePage = () => {
    return (
        <>
            <MainContent
                preTitle="İşletmem İçin"
                image={imported_asset_index_tsx_0}
                title="YemeksepetiPay ile Online Ödemelerinizi Hızlı ve Güvenli Bir Şekilde Alın!"
                text="YemeksepetiPay Sanal POS’u ile online sipariş ödemelerinizi hızlı, güvenli ve avantajlı komisyonlarla alabileceksiniz!"
                dotsDireciton/>

            <MainBoxes
                preTitle="Özelliklerimiz"
                title="Neden YemeksepetiPay Sanal POS’u?"
                items={[{
                    title: "Ödemelerinizi Ertesi Gün Alma İmkanı",
                    text: "Ertesi gün vade süresiyle çalışma opsiyonumuz ile ödemelerinizi ertesi gün alabileceksiniz.",
                    image: imported_asset_index_tsx_1
                },
                    {
                        title: "Üye İş Yeri Paneli ve Raporlama Özelliği",
                        text: "Üye iş yeri paneli üzerinden bakiyenizi ve işlem detaylarınızı kolayca takip edebileceksiniz.",
                        image: imported_asset_index_tsx_2
                    },
                    {
                        title: "Güvenli Ödeme Hizmeti",
                        text: "Tecrübeli ekibimiz ve güçlü altyapımız ile tahsilat işlemlerinizde daima güvende olduğunuzu hissedeceksiniz.",
                        image: imported_asset_index_tsx_3
                    }]}/>
        </>
    )
}

export default HomePage;